/**
 * React Query keys for onboarding management
 */

export const queryKey = {
  getOnboardingAccountList: 'ONBOARDING_GET_ACCOUNT_LIST',
  getOnboardingAccountDetail: 'ONBOARDING_GET_ACCOUNT_DETAIL',
  getOnboardingAccountByEmail: 'ONBOARDING_GET_ACCOUNT_BY_EMAIL',
  getAccountCountByStatus: 'ONBOARDING_GET_ACCOUNT_COUNT_BY_STATUS',
  getAllAccountCountsByStatus: 'ONBOARDING_GET_ALL_ACCOUNT_COUNTS_BY_STATUS',
};
